export default new class {
    set() {
        let el = document.getElementById('mainwrapper');

        let classes = el.className.split(' ');

        if (classes.indexOf('hasfixedtabs') === -1) {
            el.className += ' hasfixedtabs';
        }
    }

    unset() {
        let el = document.getElementById('mainwrapper');
        el.className = el.className.replace(/\bhasfixedtabs\b/g, '');
    }
}
